// function setSectionHeight() {
//   let section = document.querySelector('.product-gallery__ar-wrapper');
//   if (!section) {
//     console.error('Section element not found. Check the class name.');
//     return;
//   }

//   let sectionHeight = section.offsetHeight + 'px';
//   document.documentElement.style.setProperty('--pdp-product-gallery', sectionHeight);
// }
// setSectionHeight();
// window.addEventListener('resize', setSectionHeight);

{
  function setSectionHeight() {
    const arWrapper = document.querySelector('.product-gallery__ar-wrapper');
    const thumbnailWrapper = document.querySelector('.product-gallery__thumbnail-list-wrapper');
    
    if (arWrapper) {
      const arHeight = arWrapper.offsetHeight;
      // const currentThumbHeight = thumbnailWrapper.offsetHeight;      
      document.documentElement.style.setProperty('--pdp-product-gallery', `${arHeight}px`);
    }
  }
  setSectionHeight();
  window.addEventListener('resize', setSectionHeight);
}

{
  window.setGridHeight = (selector) => {
    let gridOffsets = [];
    let gridRowOffsets = []
 
    gridOffsets = Array.from(document.querySelectorAll(selector)).map((element,index) => {
      let grid = element.closest('.griditem') || element.closest('[data-equal]');
      element.removeAttribute('style');
      return {
        selector:element,
        selectorHeight: element.offsetHeight,
        offsetTop: grid.offsetTop,
      }
    });
 
    let offsets = gridOffsets.map(element => element.offsetTop);
    gridRowOffsets = [...new Set(offsets)];
 
    gridRowOffsets.forEach(rowOffset => {
      let rowGrids = gridOffsets.filter(grid => (grid.offsetTop == rowOffset));
      let comanElementHeight = Math.max.apply(Math,(rowGrids.map(ele => ele.selectorHeight)));
      rowGrids.forEach(grid => {
        grid.selector.style.minHeight = comanElementHeight+'px';
      });
    });
  }
 
 setTimeout(() => {
    matchHeightCallback();
  }, 2000)
  
  window.addEventListener('resize', function(event){
    matchHeightCallback();
  });
 
  let matchHeightCallback = () => {
    window.setGridHeight('.item_boxs.custom_image .box_item'); 
  }
  matchHeightCallback();
}